import { Component, Input } from '@angular/core';
import { Order } from '../../shared/entities/order/order';

@Component({
  selector: 'app-order-operated-rental-protocols-view, [app-order-operated-rental-protocols-view]',
  templateUrl: './order-operated-rental-protocols-view.component.html',
  styleUrls: ['./order-operated-rental-protocols-view.component.scss']
})
export class OrderOperatedRentalProtocolsViewComponent {
  
  @Input() order: Order;

}
